import { ShieldIcon } from './icons';

export function Disclaimer({ text }: { text: string }) {
  return (
    <div class="disclaimer">
      <ShieldIcon />
      <span>{text}</span>
    </div>
  );
}
